export const collegeFinderProject = {
    'title': 'College Finder',
    'desc': 'A web app for finding colleges as well as their information in a country',
    'type': 'Frontend Web Project',
    'tools': ['React Js', 'Bootstrap CSS', 'Prime CSS', 'Restful API'],
    'url': 'https://github.com/MoQuayson/college-finder'
};

export const easyFixProject = {
    'title': 'Easy Fix',
    'desc': 'A web app for optimize, manage and keep track of maintenance activities',
    'type': 'Full Stack Web Project',
    'tools': ['React Js', 'Bootstrap CSS', 'Prime CSS', 'Laravel', 'Postgres SQL'],
    'url': 'https://github.com/MoQuayson/Easy-Fix'
};

export const officeLeaveProject = {
    'title': 'Office Leave',
    'desc': "A web app to handle leave requests of employees",
    'type': 'Full Stack Web Project',
    'tools': ['Bootstrap CSS', 'JQuery', 'ASP.Net Core', 'MS SQL Server'],
    'url': 'https://github.com/MoQuayson/Office-Leave'
};

export const labDiagnosticsProject = {
    'title': 'Lab Diagnostics',
    'desc': 'A web app for managing lab diagnosis',
    'type': 'Full Stack Web Project',
    'tools': ['Bootstrap CSS', 'React', 'Laravel', 'Postgres SQL'],
    'url': 'https://github.com/MoQuayson/lab-diagnostics'
};

export const docuConvertProject = {
    'title': 'DocuConvert2Pdf',
    'desc': 'Bulk Word to PDF Converter Background Service (LibreOffice 7) for .NET 6',
    'type': 'Background Service Project',
    'tools': ['C#.Net', 'LibreOffice 7','Background Worker'],
    'url': 'https://github.com/MoQuayson/DocuConvert2Pdf'
};

export const eWalletProject = {
    'title': 'Go-Wallet-API',
    'desc': `An e-wallet API for managing digital wallets.`,
    'type': 'Background Service Project',
    'tools': ['Go', 'GoFiber','PostgresSql','Docker'],
    'url': 'https://github.com/MoQuayson/go-wallet-api'
};